import React from 'react';
import { FieldPath, FieldValues, useController, UseControllerProps } from 'react-hook-form';

import { Checkbox } from '../Checkbox/Checkbox';
import { FormControlLabel, FormControlLabelProps } from '../FormControlLabel/FormControlLabel';

export interface CheckboxFormItemProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> {
  // -- UseControllerProps -- //
  name: UseControllerProps<TFieldValues, TName>['name'];
  control: UseControllerProps<TFieldValues>['control'];

  // -- FormControlLabelProps -- //
  disabled?: FormControlLabelProps['disabled'];
  label: FormControlLabelProps['label'];
  sx?: FormControlLabelProps['sx'];
}

export const CheckboxFormItem = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(
  props: CheckboxFormItemProps<TFieldValues, TName>
) => {
  const { name, control, disabled, label, sx } = props;

  const { field } = useController({
    name,
    control
  });

  const { onChange, value } = field;

  return (
    <FormControlLabel
      control={
        <Checkbox
          color='primary'
          checked={!!value || false}
          onChange={(e) => (e.target.checked ? onChange(true) : onChange(false))}
        />
      }
      label={label}
      disabled={disabled}
      sx={sx}
    />
  );
};
